import { useMemo } from 'react';

/**
 * Proposals where the caller is a listed approver and it is their turn,
 * derived from the shared useToolRequests() result. Optional card: a failed
 * or disabled source yields no rows, so the card hides rather than showing an
 * error box to people who may not be approvers at all.
 */
export default function useProposalsToApprove(proposals) {
  const rows = useMemo(() => (proposals?.status === 'ready'
    ? proposals.rows.filter((r) => r.is_approver && r.status === 'pending_manager')
    : []), [proposals]);
  return { rows };
}
